import {Injectable} from '@angular/core';
import {History, HistoryStore} from '@app/core/state/history/history.store';
import {
  addEntities,
  deleteEntitiesByPredicate,
  getAllEntitiesApply,
  getEntitiesCountByPredicate,
  getEntityByPredicate, upsertEntities
} from "@ngneat/elf-entities";

@Injectable({providedIn: 'root'})
export class HistoryService<T> {

  private MAX_SAVED_ENTRIES = 5;

  constructor(private historyStore: HistoryStore) {
  }

  getHistory(key: string) {
    if (this.historyStore.data.getValue()) {
      return this.historyStore.data.query(getAllEntitiesApply({filterEntity: (e) => e.category === key}))
        .slice(0, this.MAX_SAVED_ENTRIES);
    }
    return [];
  }

  addToHistory(key: string, id: string, value: T): void {
    if (this.historyStore.data.getValue()) {
      if (this.historyStore.data.query(getEntitiesCountByPredicate(e => e.category === key)) >= this.MAX_SAVED_ENTRIES &&
        !this.historyStore.data.query(getEntityByPredicate(e => e.id === (key + id)))) {
        const allHistory = this.historyStore.data.query(getAllEntitiesApply({filterEntity: (e) => e.category === key}));
        this.historyStore.data.update(deleteEntitiesByPredicate(e => e.id === allHistory[0].id));
      }
    }
    this.historyStore.data.update(upsertEntities({
      entry: value,
      category: key,
      id: key + id
    } as History));
  }

  deleteItem(key: string, id: string): void {
    this.historyStore.data.update(deleteEntitiesByPredicate(e => e.id === (key + id)));
  }

  clearHistoryStore() {
    this.historyStore.data.reset();
  }
}
